<template>
  <div>
    <div class="row border-bottom">
      <div class="col-md-12 col text-center">
        <h3 v-translate:change_password="lang">Change Password</h3>
      </div>
    </div>
    <div id="profile" class="pl-100 pr-100 pt-60 pb-60">
      <div id="profile-tab" class="change-pass-section">
        <div class="form-group">
          <input :tabindex="1" type="password" autocomplete="false" name="oldPassword" class="form-control form-control-lg" v-model="participantData.oldPassword" v-on:keyup="validateConfirmPassword()" required />
          <label v-translate:enter_old_password="lang">Old password</label>
          <p v-if="validationFail.oldpassword" class="error-style confirmPassword" v-translate:OLD_PASSWORD_IS_INCORRECT="lang">
            Old password is incorrect. Please try again.
          </p>
        </div>

        <div class="form-group input-icons" style="margin-bottom:0 !important">
          <input
            :tabindex="2"
            type="password"
            autocomplete="false"
            name="newPassword"
            class="form-control form-control-lg"
            v-on:keyup="validPassword(participantData.newPassword), validateConfirmPassword()"
            :class="{
              input: true,
              'is-danger': errors.has('newPassword'),
              'is-success': !errors.has('newPassword')
            }"
            v-model="participantData.newPassword"
            required
          />
          <label v-translate:enter_new_password="lang">New password</label>
          <p v-show="errors.has('newPassword')" class="error-style confirmPassword" v-translate:error_password="lang">
            Password fild is required
          </p>
        </div>
        <div class="regex-req">
          <ul class="validation-list pt-12">
            <li>
              <span
                v-if="passwordValidations.isValidLength !== null"
                :class="{
                  success: passwordValidations.isValidLength,
                  error: !passwordValidations.isValidLength
                }"
                aria-hidden="true"
              ></span>
              <span v-else class="initial-state" aria-hidden="true"></span>
              <span class="form-check-label" v-translate:password_minchar="lang">min. 8 characters</span>
            </li>
            <li>
              <span
                v-if="passwordValidations.isValidLetter !== null"
                :class="{
                  success: passwordValidations.isValidLetter,
                  error: !passwordValidations.isValidLetter
                }"
                aria-hidden="true"
              ></span>
              <span v-else class="initial-state" aria-hidden="true"></span>
              <span class="form-check-label" v-translate:pass_requirment_min_one_letter="lang">at least 1 letter</span>
            </li>
            <li>
              <span
                v-if="passwordValidations.isValidNumber !== null"
                :class="{
                  success: passwordValidations.isValidNumber,
                  error: !passwordValidations.isValidNumber
                }"
                aria-hidden="true"
              ></span>
              <span v-else class="initial-state" aria-hidden="true"></span>
              <span class="form-check-label" v-translate:password_onenumber="lang">at least 1 number (12345)</span>
            </li>
            <li>
              <span
                v-if="passwordValidations.isValidSpecial !== null"
                :class="{
                  success: passwordValidations.isValidSpecial,
                  error: !passwordValidations.isValidSpecial
                }"
                aria-hidden="true"
              ></span>
              <span v-else class="initial-state" aria-hidden="true"></span>
              <span class="form-check-label" v-translate:PASS_REQUIREMENT_MIN_ONE_SPECIAL_CHAR="lang">at least 1 symbol (!@#$%&)</span>
            </li>
          </ul>
        </div>

        <div class="form-group re-enter-pwd">
          <input
            :tabindex="3"
            type="password"
            name="confirmPassword"
            class="form-control form-control-lg"
            v-on:keyup="validateConfirmPassword()"
            :class="{
              input: true,
              'is-danger': errors.has('confirmPassword'),
              'is-success': !errors.has('confirmPassword')
            }"
            v-model="confirmPassword"
            required
          />
          <label v-translate:confirm_new_password="lang">Confirm new password</label>
          <p class="error-style confirmPassword" v-if="showError" v-translate:pweb_error_password_notmatch="lang">
            Passwords do not match. Please try again.
          </p>
          <p class="error-style confirmPassword" v-if="errorMsg">
            {{ this.errorMsg }}
          </p>
        </div>

        <div class="text-right pt-100">
          <button class="btn btn-confirm primary-bg" :disabled="!isValid" @click.stop="changePassword()" v-translate:CONFIRM_BUTTON_TITLE="lang">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Validations, Widget, ParticipantPortal } from "@/components/services/participant-service";

export default {
  name: "change-password",
  data() {
    return {
      showPasswordErrors: false,
      widget: new Widget(),
      validate: new Validations(),
      portal: new ParticipantPortal(),
      policy: "",
      pid: "",
      globalElement: null,
      oldPasswordToValidate: null,
      confirmPassword: "",
      participantData: {
        newPassword: "",
        oldPassword: ""
      },
      passwordValidations: {
        isValidLetter: null,
        isValidNumber: null,
        isValidSpecial: null,
        isValidLength: null
      },
      parsswordValidator: {
        minLength: 8,
        minLetter: 1,
        minNumber: 1,
        minSpecial: 1,
        regSpecial: new RegExp("^(?=.*[!\"@#$%&'(\)*+,-./:;<=>?\[\\\]^_{|}~]).+$"),
        regLetter: new RegExp(/\p{L}/, "gu"),
        regNumber: new RegExp(/\p{N}/, "gu")
      },
      show: false,
      minValid: false,
      numbervalid: false,
      specialValid: false,
      showError: false,
      confirmEnable: true,
      errorMsg: false,
      letterValid: false,
      isDisabled: true,
      validationFail: { oldpassword: false }
    };
  },
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    isValid() {
      let areFieldOptionsValid = false;
      const filterKeys = ["isValidLetter", "isValidNumber", "isValidSpecial", "isValidLength"];
      const validOptions = Object.entries(this.passwordValidations).filter(e => filterKeys.includes(e[0]) && e[1] == true);
      areFieldOptionsValid = validOptions.length >= 4;

      if (areFieldOptionsValid) {
        return this.participantData.newPassword == this.confirmPassword && this.participantData.newPassword !== this.participantData.oldPassword;
      } else {
        return false;
      }
    }
  },
  methods: {
    changePassword() {
      if (this.participantData.oldPassword == this.participantData.newPassword) {
        this.$toastr.warning(this.widget.translate("old_password_new_password_not_same", "Old password and new password should not same."));
      } else {
        this.validationFail.oldpassword = false;
        if (this.pwebCognitoAuthentication) {
          this.portal
            .changeCognitoPassword(this.participantData.oldPassword, this.participantData.newPassword)
            .then(() => {
              this.$toastr.success(this.widget.translate("CHANGED_PASSWORD", "Password changed successfully"));
              this.$router.push({
                name: "participants-portal-profile-settings"
              });
            })
            .catch(error => {
              this.validationFail.oldpassword = true;
              if (error && error.message) {
                this.$toastr.error(error.message);
              }
            });
        } else if (!this.errors.any()) {
          this.$api
            .changePassword(this.participant.pid, this.participantData)
            .then(() => {
              this.$toastr.success(this.widget.translate("CHANGED_PASSWORD", "Password changed successfully"));
              this.$router.push({
                name: "participants-portal-profile-settings"
              });
            })
            .catch(() => {
              this.validationFail.oldpassword = true;
            });
        }
      }
    },
    validateConfirmPassword() {
      this.isDisabled = true;
      this.showError = false;

      if (this.participantData.newPassword === this.confirmPassword && this.participantData.oldPassword != "" && this.minValid && this.numbervalid && this.specialValid) {
        this.isDisabled = false;
      } else if (this.participantData.newPassword === "") {
        this.showError = false;
      } else if (this.participantData.newPassword == this.confirmPassword) {
        this.showError = false;
      } else if (this.confirmPassword != "") {
        this.showError = true;
      }

      if (this.oldPasswordToValidate !== this.participantData.oldPassword) {
        this.validationFail.oldpassword = false;
        this.oldPasswordToValidate = this.participantData.oldPassword;
      }
    },
    validPassword(password) {
      this.passwordValidations = this.validate.password(password, this.parsswordValidator);
    }
  }
};
</script>

<style scoped lang="scss">
.study-info-container {
  .regex-req {
    font-size: 12px;
    margin-top: 10px;
    .req-title {
      font-family: Roboto-Bold;
      color: #959fa4;
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      color: #b0bac9;
      li {
        margin: 0;
        span {
          margin-right: 8px;
          display: inline-block;
          vertical-align: middle;
          &.initial-state {
            border: 2px solid;
            min-width: 13px;
            min-height: 13px;
          }
          &.success {
            background: url("/static/img/participant-web-img/success-icon.svg") no-repeat center;
            min-height: 15px;
            min-width: 15px;
            border: 0;
          }
          &.error {
            background: url("/static/img/participant-web-img/error-icon.svg") no-repeat center;
            min-height: 15px;
            min-width: 15px;
            border: 0;
          }
        }

        @keyframes spinner-border {
          to {
            transform: rotate(360deg);
          }
        }

        .spinner-border {
          display: inline-block;
          width: 13px;
          height: 13px;
          vertical-align: text-bottom;
          border: 0.2rem solid currentColor;
          border-right-color: transparent;
          // stylelint-disable-next-line property-blacklist
          border-radius: 50% !important;
          animation: spinner-border 0.75s linear infinite;
        }

        .spinner-border-sm {
          width: 13px;
          height: 13px;
          border-width: 0.2rem;
        }
      }
    }
  }
}
#profile-tab .form-group {
  position: relative;
  margin: 30px 0 !important;
}
.input-icons .icons {
  position: absolute;
  right: 0;
  cursor: pointer;
  margin-top: 5px;
  opacity: 0.5;
}
.icons {
  padding: 10px;
  min-width: 40px;
}
.btn-ok_submit {
  font-size: 17px;
  color: #ffffff;
  width: auto;
  height: 44px;
  border-radius: 12px;
  background-color: var(--secondary);
}
.confirmPassword {
  margin-top: 3px;
  color: red;
}
p.error-style.confirmPassword {
  margin-top: 6px;
  margin-bottom: 0;
}

.createPassword-bg {
  background: url("/static/img/bg/login_bg.png") no-repeat center center fixed;
  background-color: #34537d;
  background-size: cover;
}

h1,
h2 {
  font-weight: normal;
  color: #34537d;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 0 10px;
}

a {
  color: #34537d;
}

.password-text {
  color: #34537d;
  font-size: 14px;
  margin-bottom: 0;
}

.validation-list {
  margin-left: 5px;
  span {
    margin-right: 8px;
    display: inline-block;
    vertical-align: middle;
    &.initial-state {
      border: solid 1px rgba(0, 0, 0, 0.12);
      min-width: 13px;
      min-height: 13px;
    }
    &.success {
      background: url("/static/img/participant-web-img/success-icon.svg") no-repeat center;
      min-height: 15px;
      min-width: 15px;
      border: 0;
    }
    &.error {
      background: url("/static/img/participant-web-img/error-icon.svg") no-repeat center;
      min-height: 15px;
      min-width: 15px;
      border: 0;
    }
  }
}

ul.validation-list li {
  list-style-type: none !important;
  padding-top: 5px;
  font-size: 12px;
  color: #08131f;
}

.p-style {
  color: #8c8c8c;
  font-size: 14px;
  margin-bottom: 0;
}

.icon-invalid {
  color: red;
}

.icon-valid {
  color: limegreen;
}

.border-radius20 {
  border-radius: 20px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
}

.btn-disabled {
  color: white;
  background-color: #c6c2c2 !important;
  border: #c6c2c2;
}

.container {
  padding-top: 80px;
}

.passw-block {
  max-width: 360px;
  margin: 0 auto;
}

.card-title {
  margin-bottom: 12px;
  margin-top: 3px;
  margin-right: -9px;
  letter-spacing: -0.5px;
}

.heading {
  text-align: center;
  font-size: 30px;
  max-width: 75%;
  margin: 0 auto 20px;
}

.card-body {
  padding: 15px;
}

[type="checkbox"][readonly="readonly"]::before {
  background: rgba(255, 255, 255, 0.5);
  content: "";
  display: block;
  height: 100%;
  width: 100%;
}
.ckeckInput {
  pointer-events: none;
}
#profile .btn-confirm {
  font-size: 17px;
  color: #ffffff;
  width: 100%;
  margin: auto;
  height: 44px;
  max-width: 200px;
  border-radius: 12px;
  background-color: var(--secondary);
}
#profile-tab .form-group label {
  font-size: 12px;
  position: absolute;
  top: -15px;
  left: 17px;
  padding: 5px;
  background-color: white;
}
#profile-tab.change-pass-section .validation-list li {
  margin: 0 !important;
  padding: 0;
}

#profile-tab.change-pass-section .validation-list li .form-check-label {
  font-size: 12px;
  line-height: 1.67;
  text-align: left;
  color: rgba(0, 0, 0, 0.6);
}
#profile-tab.change-pass-section .btn-confirm {
  max-width: 100% !important;
}
#profile-tab.change-pass-section .re-enter-pwd {
  background-color: #f2f2f2;
  border: none;
}
#profile-tab.change-pass-section .re-enter-pwd input {
  background-color: #f2f2f2;
}
#profile-tab.change-pass-section .form-group {
  margin: 40px 0 !important;
}
</style>
